module.exports = __webpack_public_path__ + "img/no-signal.54008689.svg";